<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item v-for="route in permission_routes" :key="route.name" :item="route" :base-path="route.path"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import {mapGetters} from 'vuex'
import SidebarItem from './SidebarItem'
import store from "@/store";
import {checkSuccess, getSideBarItems} from "@/api/Apis";
import * as LogUtil from "@/utils/logUtil";
import {SetSideBarVisible} from "@/store/action-types";
import {SET_ROUTES, SET_SIDE_BAR_ITEMS} from "@/store/mutation-types";
import {constantRouterMap} from "@/router";
import {setSideBarsVisible} from "@/utils/sideBarUtil";

export default {
  components: { SidebarItem },
  watch:{
    devMode(val){
      //更新一下 sideBarItems
      getSideBarItems({schoolId:store.getters.schoolId,devMode:store.getters.devMode}).then( (res)=>{
        if(!checkSuccess(res)) return []
        let sideBarItems = res.data.data.sideBarItems
        store.commit('permission/'+SET_SIDE_BAR_ITEMS,sideBarItems)
        let newRoutes = setSideBarsVisible(constantRouterMap,sideBarItems)
        store.commit('permission/'+SET_ROUTES, newRoutes)
      })
    },
    isCollapse(value){
      if(!value){

        if(!store.getters.sideBarItems || store.getters.sideBarItems.length <= 0){
          LogUtil.d("getSideBarItems isCollapse:"+value)
          //更新一下 sideBarItems
          getSideBarItems({schoolId:store.getters.schoolId,devMode:store.getters.devMode}).then( (res)=>{
            if(!checkSuccess(res)) return []
            let sideBarItems = res.data.data.sideBarItems
            store.commit('permission/'+SET_SIDE_BAR_ITEMS,sideBarItems)

            LogUtil.d(" sideBarItems:",sideBarItems)
            console.log("SetSideBarVisible",constantRouterMap)
            let newRoutes = setSideBarsVisible(constantRouterMap,sideBarItems)
            store.commit('permission/'+SET_ROUTES, newRoutes)
          })
        }

      }
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    devMode(){
      return store.getters.devMode
    },
    routes() {
      return this.$router.options.routes
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue